<template>
  <div ref="inputContainer" class="input-container w-100">
    <transition name="fadeUpShort">
      <div v-if="filters" v-show="open" class="filter-box">
        <slot name="filter" />
      </div>
    </transition>
    <b-input-group class="input-group-labeled">
      <b-input-group-prepend>
        <b-dropdown
          v-if="options.orderBy"
          class="text-nowrap"
          menu-class="no-ws dropdown-menu-animated"
          variant="secondary"
          @click.native="$emit('onSearch')"
        >
          <template #button-content>
            <b-icon
              :icon="activeSort.sort === 'asc' ? 'sort-up' : 'sort-down'"
              class="mr-1"
            />
          </template>
          <b-dropdown-item @click.prevent="changeSort('asc')">
            <icon
              v-if="activeSort.sort === 'asc'"
              class="icon-fw ml-2 float-right mt-1"
              name="check"
              scale="0.75"
            />
            <icon class="icon-fw mr-1" name="sort-amount-up" scale="0.75" />
            Vzostupne
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="changeSort('desc')">
            <icon
              v-if="activeSort.sort === 'desc'"
              class="icon-fw ml-2 float-right mt-1"
              name="check"
              scale="0.75"
            />
            <icon class="icon-fw mr-1" name="sort-amount-down" scale="0.75" />
            Zostupne
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            v-for="(sort, key) in options.sortable"
            :key="key"
            @click.prevent="changeCol(sort)"
          >
            <icon
              v-if="sort === activeSort.column"
              class="icon-fw ml-2 float-right mt-1"
              name="check"
              scale="0.75"
            />
            <template v-if="options.headings && options.headings[sort]">
              {{ options.headings[sort] }}
            </template>
            <template v-else> - </template>
          </b-dropdown-item>
        </b-dropdown>
        <div
          v-if="activeFilters > 0"
          class="d-flex align-items-center m-1 px-2 bg-primary text-white"
        >
          Filtrované:
          <b-badge class="fs-base ml-1" variant="light">
            {{ activeFilters }}
          </b-badge>
        </div>
      </b-input-group-prepend>
      <b-form-input
        v-model="value"
        class="border-left-0 border-right-0"
        placeholder="Filtrovanie a hľadanie..."
        size="lg"
        @focus="openBox"
        @keydown.enter="search"
      />
      <b-input-group-append>
        <b-btn v-if="value" variant="link" @click="reset">
          <b-icon icon="x-circle" />
        </b-btn>
        <b-btn variant="link" @click="search">
          <b-icon icon="search" />
        </b-btn>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
import collect from 'collect.js'

export default {
  props: {
    options: {
      type: Object,
    },
    filters: {
      type: Object,
    },
    storage: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      value: null,
      activeSort: {},
      open: false,
    }
  },
  computed: {
    params() {
      let output = {}
      output = {
        filter: this.filters,
        query: this.value,
        startAt: 0,
        maxResults: 20,
        orderBy: {},
      }
      if (this.options.searchIn) {
        output.searchIn = this.options.searchIn
      }
      output.orderBy[this.activeSort.column] = this.activeSort.sort

      return output
    },
    activeFilters() {
      let filters = {}
      collect(this.filters).each((item, key) => {
        if (item && (Object.keys(item).length || Array.isArray(item))) {
          filters[key] = !collect(item).filter()
        } else {
          filters[key] = !!item
        }
      })
      return collect(filters).filter().count()
    },
  },
  mounted() {
    document.addEventListener('click', this.documentClick)

    if (this.options.orderBy) {
      this.activeSort = {
        column: this.options.orderBy.column,
        sort: !this.options.orderBy.ascending ? 'asc' : 'desc',
      }
    }

    //fix old localstorage key
    if (localStorage.getItem(this.storage + '-col') === 'company_name') {
      localStorage.setItem(this.storage + '-col', 'name')
    }

    if (localStorage.getItem(this.storage + '-col')) {
      this.activeSort.column = localStorage.getItem(this.storage + '-col')
    }

    if (localStorage.getItem(this.storage + '-sort')) {
      this.activeSort.sort = localStorage.getItem(this.storage + '-sort')
    }
  },
  beforeDestroy: function () {
    document.removeEventListener('click', this.documentClick)
  },
  methods: {
    search() {
      this.$emit('onSearch', this.value)
    },
    reset() {
      this.value = null
      this.$emit('onReset')
    },
    documentClick(e) {
      let el = this.$refs.inputContainer
      let target = e.target
      if (el !== target && !el.contains(target)) {
        this.open = false
      }
    },
    changeCol(val) {
      this.activeSort.column = val
      this.saveState()
    },
    changeSort(val) {
      this.activeSort.sort = val
      this.saveState()
    },
    saveState() {
      if (this.storage) {
        localStorage.setItem(this.storage + '-col', this.activeSort.column)
        localStorage.setItem(this.storage + '-sort', this.activeSort.sort)
        localStorage.setItem(
          this.storage + '-filter',
          JSON.stringify(this.filters),
        )
      }
    },
    openBox() {
      this.open = true
    },
    closeBox() {
      this.open = false
    },
  },
}
</script>
